import { useRef, useEffect, useContext } from "react";
import Chart from "chart.js/auto";
import { Spin } from "antd";
import { STATUS } from "../../constants";
import { memo } from "react";
import { UserContext } from "../../context"

const Chart3 = memo(({ kanbanFilterInfo, status }) => {
  const { parkId } = useContext(UserContext);
  const element = useRef();
  const filterData = kanbanFilterInfo.filter((item) => item.cloumn === 3);
  const allyear = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 4 + index
  );
  useEffect(() => {
    let counts = [];
    if (filterData.length > 0) {
      counts = filterData[0].context.map((item) => item.count);
    }
    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: allyear,
        datasets: [
          {
            data: parkId === 69 ? [34, 53, 63, 65, 71] : [0, 0, 0, 0].concat(counts),
            fill: true,
            borderColor: "#e76f51",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,

            ticks: { stepSize: 1 },
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: false,
        },
      },
    });
    return () => chart.destroy();
  }, [filterData, allyear]);
  return (
    <Spin spinning={status === STATUS.idle}>
      <canvas ref={element} />
    </Spin>
  );
});

export default Chart3;
